export const WARNING_BONUS_CLASS_USER = 'warningBonusClassUser';
export const BUTTON_ACTIONS_GROUP_LICENSES = [
  { key: '1', value: 'actions.sendStartClassEmail', profile: 'licenses.resendStartClassEmail' },
  { key: '2', value: 'actions.downloadDiploma', profile: 'licenses.download' },
  { key: '3', value: 'actions.downloadReport', profile: 'licenses.download' },
  { key: '4', value: 'actions.changeGroup', profile: 'licenses.changeGroup' },
  { key: '5', value: 'actions.sendPersonalizedEmail', profile: 'students.sendPersonalizedEmail' }
];
export const DEFAULT_LIST_VALUES = {
  aggregates: null,
  filters: {},
  limit: 10,
  page: 1,
  populate: null,
  search: null,
  sort: null
};

export const DEFAULT_STUDENT_ACTIVITY = {
  total: 0,
  averageDuration: 0,
  totalDuration: 0,
  averageProgress: 0,
  progressSections: [0, 0, 0, 0, 0, 0]
};
